import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../addons.css";
import AuthContext from "../../../contexts/AuthProvider";
import { useContext } from "react";
import { API_URL } from "../../../utils/config";
const baseUrl = API_URL;

function DeleteDish({ onClose, catering_id, venue_id }) {
  const { t } = useTranslation("dish");
  const [isDeleting, setIsDeleting] = useState(false);
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
const { isAuthenticated } = useContext(AuthContext);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      if (!isAuthenticated) {
        return;
      }
      const response = await fetch(
        `${baseUrl}/api/v1/attnd-venue/caterings/${catering_id}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        }
      );

      if (!response.ok) {
        throw new Error(t("deleteDish.errors.deleteFailed"));
      }

      console.log("Catering deleted successfully!");
      onClose();
    } catch (error) {
      console.error("Error deleting the catering:", error);
      alert(t("deleteDish.errors.deleteFailed"));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="invite-attendee-modal">
      <div className="delete-modal">
        <button className="close-icon" onClick={onClose} disabled={isDeleting}>
          <img src="/x.svg" alt={t("deleteDish.altClose")} />
        </button>
        <h3 className="delete-heading">{t("deleteDish.heading")}</h3>
        <p className="delete-desc">{t("deleteDish.description")}</p>
        <div className="delete-btns">
          <button
            type="button"
            className="cancel-delete"
            onClick={onClose}
            disabled={isDeleting}
          >
            {t("deleteDish.buttons.cancel")}
          </button>
          <button
            type="button"
            className="addons-delete"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {t("deleteDish.buttons.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteDish;
